// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3UZwG","label":"Category_label___G963","content":"Category_content__2Molr","header":"Category_header__2pLBM","location":"Category_location__1lHad"};